import { FunctionComponent, useContext } from "react";
import { Price as KandaPrice } from "@kanda-libs/ks-design-library";
import LineItemContext from "components/job/LineItem/LineItemContext";

export interface PriceProps {}

const Price: FunctionComponent<PriceProps> = () => {
  const { price, classNames } = useContext(LineItemContext);

  return <KandaPrice {...classNames.price} amount={price} />;
};

export default Price;
